import { fetchQuery, graphql } from 'react-relay';

import { getRelayEnvironment } from '@confluence/graphql-provider/entry-points/relayEnvironment.ts';

import type { DocumentContributorsRefreshQuery } from './__generated__/DocumentContributorsRefreshQuery.graphql.ts';

const query = graphql`
	query DocumentContributorsRefreshQuery($contentId: ID!) {
		contentContributors(id: $contentId, limit: 4) {
			...ByLineContributors_contentContributors
			...NudgeContributorFilter_contentContributors
			...SmartsFeedbackComponent_contentContributors
			...PageHeaderLoomButton_contentContributors
		}
	}
`;

// ContentContributors has no schema id: the limit is part of the Relay record identity.
// Use the document's Relay environment even if the ownership mutation used Apollo.
export const refreshDocumentContributors = async (contentId: string): Promise<void> => {
	const environment = getRelayEnvironment();
	try {
		await fetchQuery<DocumentContributorsRefreshQuery>(
			environment,
			query,
			{ contentId },
			{ fetchPolicy: 'network-only' },
		).toPromise();
	} catch (error) {
		// Drop the stale decision so mounted status readers select their query-backed fallback.
		environment.commitUpdate((store) => {
			store
				.getRoot()
				.getLinkedRecord('contentContributors', { id: contentId, limit: 4 })
				?.setValue(null, 'isCurrentUserContributor');
		});
		throw error;
	}
};
